export default function IconLayers(props) {
  return (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" {...props}>
      <path d="M12 2l10 6-10 6L2 8z"/><path d="M2 16l10 6 10-6"/>
    </svg>
  )
}
